import { RefundType } from "types/business/RefundType";
import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = RefundType[];

export const useDefaultObservableRefundTypeArray = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectRefundTypeArray extends BehaviorSubject<CurrentType> {}
